import { useLocale } from "@seller/app/locale";

type Props = {
  className?: string;
};

// Bosta's official wordmark, served from /public/integrations/. The Arabic
// and English versions look quite different, so pick by locale. Caller
// sizes via className (default h-6, tile-friendly).
export function BostaLogo({ className = "h-6 w-auto object-contain" }: Props) {
  const locale = useLocale();
  const src =
    locale === "ar"
      ? "/integrations/bosta-ar.png"
      : "/integrations/bosta-en.png";
  return <img src={src} alt="Bosta" className={className} draggable={false} />;
}
